<agr-page-toolbar
  [pageTitle]="pageTitle$ | async"
  [hasPrimaryAction]="false"
  class="somatic-cell-count-attentions"
>
  <div class="wrapper--spacing-all">
    <div class="flex--justify-space-between">
      <app-production-picker
        (productionChanged)="onProductionChanged($event)"
      ></app-production-picker>
      <mat-slide-toggle
        [hideIcon]="true"
        (change)="showOnlyAttentionsChange($event)"
        [(ngModel)]="showOnlyAttentions"
        color="primary"
      >
        {{ 'health.individual-health.showOnlyAttentionsToggleLabel' | translate }}
      </mat-slide-toggle>
    </div>

    <mat-list role="list" class="container"> </mat-list>

    <div class="table-desktop">
      <table
        mat-table
        matSort
        #table
        [dataSource]="dataSource"
        class="table-desktop__table--alternate-rows cust-table"
      >
        <ng-container matColumnDef="name">
          <th mat-header-cell mat-sort-header *matHeaderCellDef>
            {{ 'health.individual-health.somatic-cell-count-attentions-table.name' | translate }}
          </th>
          <td mat-cell *matCellDef="let element">
            <button mat-button (click)="openCowDetails(element)">
              {{ element.name }}
            </button>
          </td>
        </ng-container>
        @for (column of columnIds(); track column; let colIndex = $index) {
          <ng-container matColumnDef="{{ column }}">
            <th mat-header-cell mat-sort-header *matHeaderCellDef>
              {{ columns[colIndex].label | translate }}
            </th>
            <td mat-cell *matCellDef="let row">{{ row[column] }}</td>
          </ng-container>
        }
        @for (column of dateColumnIds(); track column; let colIndex = $index) {
          <ng-container matColumnDef="{{ column }}">
            <th mat-header-cell mat-sort-header *matHeaderCellDef>
              {{ dateColumns[colIndex].label | translate }}
            </th>
            <td
              mat-cell
              *matCellDef="let row"
              [ngClass]="setAttention(dateColumns[colIndex].id, row)"
            >
              {{ row[column] }}
            </td>
          </ng-container>
        }

        <tr mat-header-row *matHeaderRowDef="displayedColumnIds()"></tr>
        <tr mat-row *matRowDef="let row; columns: displayedColumnIds()"></tr>
      </table>
    </div>

    <agr-notification-empty
      [isEmpty]="!hasData()"
      [emptyTitle]="'no_items' | translate"
      emptyImage="/assets/images/no-items.png"
      class="complete__notification-empty"
    >
    </agr-notification-empty>
  </div>
</agr-page-toolbar>
